export enum Dialog {
  NONE,
  DELETE,
}
